import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import Loader from "../../../components/Loader";
import RequestAccess from "../../../components/requestAccess/RequestAccess";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import Utils from "../../../utils/Utils";
import WebUtils from "../../../utils/WebUtils";
import InSightMain from "../../../components/insight/InSightMain";

const userDetail = Utils.getUserDetail();

function Insights() {
  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getModuleInfo();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="insights" userRole="candidate" />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="insights"
            userRole="candidate"
            newTitle="AI Insights"
            noNavigate={true}
          />
          {/* {moduleInfo?.hasInsightAccessGranted && <div>insights data</div>}
          {moduleInfo?.hasInsightAccessGranted === false && (
            <RequestAccess moduleName="IN_SIGHT" />
          )} */}
          {/* <RequestAccess moduleName="IN_SIGHT" /> */}
          <InSightMain />
        </div>
      </div>
    </>
  );
}

export default Insights;
